import { lighten } from '@mui/material/styles';
import { defaultDashboardBrandColor } from '../DashboardLayout';

const tintRatio = 0.08;

export const getBrandTint = (brandColor?: string | null): string | undefined => {
  if (brandColor === undefined) {
    return undefined;
  }
  const color = brandColor || defaultDashboardBrandColor;
  try {
    return lighten(color, 1 - tintRatio);
  } catch {
    return lighten(defaultDashboardBrandColor, 1 - tintRatio);
  }
};
